export const UNIQUE_EMAIL = "Please enter a unique email";
export const PASSWORDS_DIFFERENT = "New Password & New Re-enter Password are not same";
export const INVALID_FORM = "Please fill the correctly & completely";
